import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowUpRight, Linkedin, Twitter, Facebook, Instagram } from "lucide-react";

const SOCIALS = [
  { key: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/sunsrisoftware/", Icon: Linkedin },
  { key: "twitter", label: "X (Twitter)", href: "https://twitter.com/username", Icon: Twitter },
  { key: "facebook", label: "Facebook", href: "https://www.facebook.com/username", Icon: Facebook },
  { key: "instagram", label: "Instagram", href: "https://www.instagram.com/username", Icon: Instagram },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-gray-200 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src="/brand/sunsri-logo.png"
              alt="Sunsri Software Private Limited"
              className="h-24 w-auto -ml-2 mb-6"
              draggable={false}
            />
            <h2 className="font-serif text-3xl md:text-4xl mt-2 leading-tight text-white">
              Engineering SAP outcomes with editorial precision.
            </h2>
            <Link to="/contact" data-testid="footer-cta" className="inline-flex items-center gap-2 mt-8 text-white border-b border-white/40 pb-1 hover:border-white transition">
              Start a conversation <ArrowUpRight size={16} />
            </Link>

            <div className="mt-10">
              <div className="overline text-gray-400 mb-4">Follow us</div>
              <ul
                data-testid="footer-socials"
                className="flex items-center gap-2 justify-center md:justify-start -ml-2 md:ml-0"
              >
                {SOCIALS.map(({ key, label, href, Icon }) => (
                  <li key={key}>
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={label}
                      title={label}
                      data-testid={`social-link-${key}`}
                      className="inline-flex items-center justify-center w-11 h-11 rounded-full text-gray-300 hover:text-[#C9A24E] hover:bg-white/5 transition-all duration-200 hover:-translate-y-0.5"
                    >
                      <Icon size={18} strokeWidth={1.6} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-gray-400 mb-5">Services</div>
            <ul className="space-y-3 text-[15px] text-gray-300">
              <li><Link to="/services" className="hover:text-white">Implementation</Link></li>
              <li><Link to="/services" className="hover:text-white">Migrations</Link></li>
              <li><Link to="/services" className="hover:text-white">Application Development</Link></li>
              <li><Link to="/services" className="hover:text-white">Integration</Link></li>
              <li><Link to="/services" className="hover:text-white">Support &amp; Maintenance</Link></li>
            </ul>

            <div className="overline text-gray-400 mt-8 mb-5">Company</div>
            <ul className="space-y-3 text-[15px] text-gray-300">
              <li><Link to="/about" className="hover:text-white">About us</Link></li>
              <li><Link to="/approach" data-testid="footer-approach-link" className="hover:text-white">Approach</Link></li>
              <li><Link to="/careers" data-testid="footer-careers-link" className="hover:text-white">Careers</Link></li>
              <li><Link to="/brochure" data-testid="footer-brochure-link" className="hover:text-white">Brochure</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-gray-400 mb-5">Contact</div>
            <ul className="space-y-5 text-[15px] text-gray-300">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-1 text-gray-400 shrink-0" />
                <span>info@sunsrisoft.com</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-1 text-gray-400 shrink-0" />
                <span className="leading-relaxed">
                  <span className="block"><span className="text-gray-500">IN</span> &nbsp;+91 87900 06313</span>
                  <span className="block"><span className="text-gray-500">USA</span> &nbsp;+1 (510) 991-6480</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 text-gray-400 shrink-0" />
                <span className="leading-relaxed">
                  <span className="block text-gray-500 text-xs uppercase tracking-[0.2em] mb-1">India</span>
                  <span className="block">301 &amp; 302, Surya Pearl Building,<br/>Opp: Raheja Mindspace IT Park,<br/>Hitech City, Hyderabad – 500081</span>
                  <span className="block text-gray-500 text-xs uppercase tracking-[0.2em] mt-3 mb-1">USA</span>
                  <span className="block">7645 Donohue Dr,<br/>Dublin CA 94568</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-gray-400">
          <div>© {new Date().getFullYear()} Sunsri Software Private Limited. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition">Privacy</Link>
            <span>Terms</span>
            <span>Sitemap</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
